export const getTopSectionCardText = label => {
  if (label === 'TOTAL' || label === 'CANCELLED' || label === 'FULFILLED' || label === 'BOOKED') {
    return `${label} Appointments`;
  }
  if (label === 'NO_SHOW') {
    return 'NO SHOWS';
  }
  return label;
};
